<template>
  <div></div>
</template>

<script>
export default {
  // LPは無くなったが復活する際に備えて、ページは開けておく。
  name: 'Index',
  beforeCreate: function () {
    this.$router.push({ name: 'Login' });
  }
};
</script>

<style scoped></style>
